export enum buttonTypesEnum {
	button = 'button',
	reset = 'reset',
	submit = 'submit',
	filter = 'filter'
}